/**
 * Created by maofaming on 2017/4/21.
 */

function addZero (num) {
    return (num > 9 ? '' : '0') + num;
}

function toFormat (date) {
    let y = date.getFullYear();
    let m = date.getMonth() + 1;
    let d = date.getDate();
    return [y, addZero(m), addZero(d)].join('/');
}

let oneDay = 24 * 60 * 60 * 1000;

module.exports = function (offset) {
    let nowDate = new Date();
    if (typeof offset === 'number') {
        let offsetDate = new Date(nowDate.getTime() + offset * oneDay);
        return toFormat(offsetDate);
    } else {
        return toFormat(nowDate);
    }
};
